export default __webpack_public_path__ + "3963fdc117d92d7e489038e8f82999d6.gif";